import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AuthCard } from "./components/constants";
import { BasicPage, Footer, LoginForm } from "./components";
import { GoogleButton } from "../../components/auth/GoogleButton";

export function LoginPage() {
  const navigate = useNavigate();
  // get the ?redirect= query param
  const queryParams = new URLSearchParams(window.location.search);
  const redirectPath = queryParams.get("redirect") || "/";

  return (
    <BasicPage>
      <AuthCard elevation={0} variant="outlined">
        <Box textAlign="center" display="flex" flexDirection="column" gap={5}>
          <Typography variant="h5">
            Log in
          </Typography>
          <LoginForm onSuccess={() => navigate(redirectPath)} />
          <GoogleButton intent="login" />
        </Box>
      </AuthCard>
      <Footer isLogin />
    </BasicPage>
  );
}
